const React = require('react');
const { Background } = require('@andes-landings/background');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const HelpIcon = require('@andes/icons/Help24');
const { Title } = require('@andes-landings/title');
const DiscordImage = require('./discord');
const { getEventTracker } = require('../../../../../utils/event-tracker');
const { isYellowBlueLightBrand } = require('../../../../../utils/isYellowBlueLightBrand');
const Tracker = getEventTracker();

const HelpComponent = ({ i18n, lang, brand }) => {
  const Container = brand === 'yellowblue-light' ? 'div' : Background;
  const containerProps = {
    className: 'help-background',
    ...(brand !== 'yellowblue-light' && {
      component: 'section',
      curves: 3,
      lowEnd: isYellowBlueLightBrand(brand),
      type: 'ending',
    }),
  };

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_help', {
      card_name: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  return (
    <Container {...containerProps}>
      <div className="help-container">
        <div className="help-sub-container">
          <Title
            className={`help-title help-title-${brand}`}
            title={i18n.gettext('¿Te ayudamos?')}
            description={i18n.gettext('Contacta a nuestro equipo técnico o comparte tus dudas en la comunidad.')}
            isHero
            align="center"
            style={{ padding: 0 }}
          />
          <div className="help-cards-container">
            <a
              href={`https://www.mercadopago.com/developers/${lang}/support/center`}
              target="_blank"
              rel="noreferrer"
              onClick={() => { Tracker.send('mpdevelopers/click_help', 'support'); sendToMelidata('support'); }}
              aria-label={i18n.gettext('Ir a Soporte técnico oficial')}
            >
              <Card className="help-card" shadow="outline" paddingSize="0">
                <CardContent className="help-card-container">
                  <HelpIcon />
                  <div className="help-card-text">
                    <h4 className="help-card-header">{i18n.gettext('Soporte técnico oficial')}</h4>
                    <span className="help-card-content">
                      {i18n.gettext('Resuelve tus consultas acerca de las integraciones, cuentas y otros asuntos técnicos con nuestro equipo especializado.')}
                    </span>
                  </div>
                </CardContent>
              </Card>
            </a>
            <a
              href="https://discord.com/invite/yth5bMKhdn"
              target="_blank"
              rel="noreferrer"
              onClick={() => { Tracker.send('mpdevelopers/click_help', 'discord'); sendToMelidata('discord'); }}
              aria-label={i18n.gettext('Ir a comunidad en Discord')}
            >
              <Card className="help-card" shadow="outline" paddingSize="0">
                <CardContent className="help-card-container">
                  <DiscordImage />
                  <div className="help-card-text">
                    <h5 className="help-card-header">{i18n.gettext('Apoyo de la comunidad')}</h5>
                    <span className="help-card-content">
                      {i18n.gettext('Comparte dudas e intercambia conocimiento con otros integradores en nuestro canal en Discord.')}
                    </span>
                  </div>
                </CardContent>
              </Card>
            </a>
          </div>
        </div>
      </div>
    </Container>);
};
module.exports = HelpComponent;
